import type * as CourseCertificationModule from '../types/CourseCertificationModule'
import { imageParser } from '../props/parsers/Image'

export default function courseCertificationModuleComponentParser(
  rawComponent: CourseCertificationModule.Raw,
): CourseCertificationModule.Parsed {
  const cards = rawComponent.courseCertificationModule

  return {
    name: 'CourseCertificationModule',
    props: {
      cards: cards.map(({ captionCard, ...card }) => ({
        ...card,
        captionCard: {
          ...captionCard,
          ...imageParser(captionCard.image),
        },
      })),
    },
  }
}
